import React from "react";
import { Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { RoutePaths } from "src/app/model";

import logoImg from "../../assets/logo.png";

export const Logo: React.FC = () => {
  const navigate = useNavigate();
  return (
    <Stack
      direction="row"
      spacing={2}
      justifyContent="center"
      alignItems="center"
      sx={{
        cursor: "pointer",
      }}
      onClick={() => navigate(RoutePaths.HOME)}
    >
      <img src={logoImg} alt="Mathrix Ai" width={40} height={40} />
      <Stack
        direction="row"
        spacing={0}
        justifyContent="center"
        alignItems="center"
      >
        <Typography
          variant="h5"
          fontWeight="normal"
          // letterSpacing={2}
          sx={{
            color: "warning.main",
            transition: "color .4s",
          }}
        >
          Mathrix
        </Typography>
        <Typography
          variant="h5"
          fontWeight="bold"
          sx={{
            color: "primary.main",
            transition: "color .4s",
            marginLeft: 0.5,
          }}
        >
          A
        </Typography>
        <Typography
          variant="h5"
          fontWeight="bold"
          sx={{
            color: "secondary.main",
            transition: "color .4s",
          }}
        >
          I
        </Typography>
      </Stack>
    </Stack>
  );
};
